<template>
  <div class="auditCashierContainer">
    <section class="dialogsBox" v-show="!rejectIsShow && auditIsShow">
      <div>
        <h3>出纳审核</h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size: 30px; color: #333" />
        </a>
        <ul v-if="details != ''">
          <li class="disStyle">
            <label>费用名称：</label>
            <p>{{ details.name }}</p>
          </li>
          <li class="disStyle">
            <label>{{ details.type == 1 ? "开票金额：" : "费用金额：" }}</label>
            <p>
              {{
                details.type == 1
                  ? Number(details.invoice_amount) + "元"
                  : Number(details.amount) + "元"
              }}
            </p>
          </li>
          <li class="disStyle">
            <label>提交人：</label>
            <p>{{ details.create_user_name }}</p>
          </li>
          <li class="disStyle">
            <label>费用所属日期：</label>
            <p>
              {{
                details.finance_date == undefined
                  ? ""
                  : details.finance_date.substring(0, 10)
              }}
            </p>
          </li>
          <li
            v-show="details.from_type == 1 && details.xf_out_account_type != 0"
          >
            <label>打款至：</label>
            <p v-show="details.xf_out_account_type == 2">员工</p>
            <p v-show="details.xf_out_account_type == 3">三方</p>
            <p v-show="details.xf_out_account_type == 4">
              {{ details.xf_other_info }}
            </p>
            <p v-show="details.xf_out_account_type == 0">未知</p>
          </li>
          <li v-show="details.from_type == 2 && details.out_account_type != 0">
            <label>打款至：</label>
            <p v-show="details.out_account_type == 1">
              {{ details.create_user_name }}
            </p>
            <p v-show="details.out_account_type == 2">员工</p>
            <p v-show="details.out_account_type == 3">三方</p>
            <p v-show="details.out_account_type == 4">
              {{ details.other_info }}
            </p>
            <p v-show="details.out_account_type == 0">未知</p>
          </li>
          <li class="disStyle">
            <label>
              <i>*</i>
              {{ details.type == 1 ? "入账日期：" : "出账日期：" }}
            </label>
            <a-date-picker v-show="details.type == 1" v-model="flow_date" />
            <p v-show="details.type == 2">{{ flow_date }}</p>
          </li>
          <li v-show="details.type == 2" class="disStyle">
            <label> <i>*</i>外包平台： </label>
            <a-radio-group v-model="is_platform">
              <a-radio :value="2">使用</a-radio>
              <a-radio :value="1">未使用</a-radio>
            </a-radio-group>
          </li>
          <li v-show="is_platform == 2 && details.type == 2" class="disStyle">
            <label> <i>*</i>外包平台：</label>
            <a-select
              style="width: 160px"
              v-model="finance_platform_id"
              @change="changeCharge"
            >
              <a-select-option
                :value="element.id"
                v-for="(element, k) in platformList"
                :key="k"
              >
                {{ element.name + "&nbsp;" + element.rate + "%" }}
              </a-select-option>
            </a-select>
          </li>
          <!-- <li v-show="is_platform == 2 && details.type == 2" class="disStyle">
            <label>费率：</label>
            <p>{{ rateVal + "%" }}</p>
          </li> -->
          <li class="disStyle" v-show="is_platform == 2 && details.type == 2">
            <label> <i>*</i>发薪手续费：</label>
            <a-input-number
              style="width:160px"
              v-model="pay_service"
              :min="0"
            />
            <span>&nbsp;元</span>
          </li>
          <li class="disStyle">
            <label>
              <i>*</i>
              {{ details.type == 1 ? "入账金额：" : "出账金额：" }}
            </label>
            <a-input-number style="width:160px" v-model="amount" :min="0" />
            <span style="line-height:32px">&nbsp;元</span>
          </li>
          <li class="disStyle">
            <label>
              <i>*</i>
              {{ details.type == 1 ? "入账账户：" : "出账账户：" }}
            </label>
            <a-select v-model="company_id" show-search style="width: 60%">
              <a-select-option
                v-for="item in companyList"
                :key="item.id"
                :value="item.id"
                >{{ item.company_name }}</a-select-option
              >
            </a-select>
          </li>
          <li>
            <label>备注：</label>
            <a-textarea v-model="remark" style="width: 80%" />
          </li>
          <li>
            <label><i>*</i>银行流水编号：</label>
            <a-input style="width:60%" v-model="bank_flow_num" />
          </li>
        </ul>
        <div>
          <a-button type="danger" @click="auditReject">驳回</a-button>
          <a-button type="primary" @click="auditPass">同意</a-button>
        </div>
      </div>
    </section>

    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectCancel">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import NP from "number-precision";
export default {
  data() {
    return {
      auditIsShow: true,
      reason: "",
      rejectIsShow: false,
      details: {},
      flow_date: moment().format("YYYY-MM-DD"),
      amount: "",
      companyList: [],
      company_id: "",
      remark: "",
      is_finish: 1,
      to_company_id: "",
      bank_flow_num: "",
      is_platform: 2,
      pay_service: "",
      finance_platform_id: "",
      platformList: [],
      rateVal: 0
    };
  },
  props: {
    auditCashierDetails: {}
  },
  watch: {
    auditCashierDetails() {
      this.getDetails();
    },
    is_platform() {
      if (this.is_platform == 1) {
        this.details.type == 1
          ? (this.amount = this.details.invoice_amount)
          : (this.amount = this.details.amount);
      } else {
        this.amount = NP.plus(Number(this.amount), Number(this.pay_service));
      }
    },
    pay_service() {
      this.details.type == 1
        ? (this.amount = this.details.invoice_amount)
        : (this.amount = this.details.amount);
      this.amount = NP.plus(Number(this.amount), Number(this.pay_service));
    }
  },
  mounted() {
    this.getCompany(); //获取公司
    if (this.auditCashierDetails != undefined) {
      this.getDetails();
    }
    this.getPlatform(); //获取外包平台
  },
  methods: {
    getPlatform() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_platform/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.platformList = res.data.data.data;
            // console.log(this.platformList);
          }
        });
    },
    changeCharge(val, option) {
      this.rateVal = Number(this.platformList[option.key].rate);
      this.details.type == 1
        ? (this.amount = this.details.invoice_amount)
        : (this.amount = this.details.amount);
      this.pay_service = (
        NP.times(this.details.amount, this.rateVal) / 100
      ).toFixed(2);
      this.amount = NP.plus(Number(this.amount), Number(this.pay_service));
    },
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.companyList = res.data.data.data;
            // console.log(this.companyList);
          }
        });
    },
    getDetails() {
      this.details = this.auditCashierDetails;
      this.details.type == 1
        ? (this.amount = this.details.invoice_amount)
        : (this.amount = this.details.amount);

      // this.amount=this.details.
      console.log(this.details);
    },
    auditReject() {
      this.rejectIsShow = true;
    },
    verify() {
      let fls = true;
      if (this.amount == "") {
        fls = false;
        this.$message.warning("请输入金额");
        return fls;
      }
      if (this.company_id == "") {
        fls = false;
        this.$message.warning("请输入账户");
        return fls;
      }
      if (this.is_finish == "") {
        fls = false;
        this.$message.warning("请选择该笔费用是否结算完成");
        return fls;
      }
      if (this.bank_flow_num == "") {
        fls = false;
        this.$message.warning("请输入银行流水编号");
        return fls;
      }
      if (
        this.details.type == 2 &&
        this.is_platform == 2 &&
        this.finance_platform_id == ""
      ) {
        fls = false;
        this.$message.warning("请选择外包平台");
        return fls;
      }
      if (
        this.details.type == 2 &&
        this.is_platform == 2 &&
        this.pay_service == ""
      ) {
        fls = false;
        this.$message.warning("请输入手续费");
        return fls;
      }
      return fls;
    },
    auditPass() {
      let fls = this.verify();
      if (fls) {
        this.auditIsShow = false;
        this.auditPassHttp();
      }
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/cashierCheckPass";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: this.details.id,
        flow_date: this.flow_date,
        amount: this.amount,
        company_id: this.company_id,
        remark: this.remark,
        // to_company_id: this.to_company_id,
        is_finish: this.is_finish == 2 ? 0 : 1,
        bank_flow_num: this.bank_flow_num,
        is_platform: this.is_platform,
        finance_platform_id: this.finance_platform_id,
        pay_service: this.pay_service
      };
      if (this.is_platform == 1) {
        delete params.finance_platform_id;
        delete params.pay_service;
      }
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.auditIsShow = true;
          this.$emit("hideInDialogCashier", true);
          this.$message.success("费用已结算完成");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    rejectCancel() {
      this.$emit("hideInDialogCashier", false);
    },
    rejectSure() {
      if (this.reason != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.finance +
          "finance/cashierCheckReject";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          reason: this.reason,
          id: this.details.id
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("申请已驳回");
            this.reason = "";
            this.rejectIsShow = false;
            this.$emit("hideInDialogCashier", true);
          } else {
            this.rejectIsShow = false;
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请输入驳回原因！");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.dialogsBox {
  > div {
    text-align: left;
    padding: 20px 40px;
    margin: 30px auto 0;
    width: 700px;
    > ul {
      > li {
        margin-bottom: 10px;
        > label,
        > p {
          line-height: 30px;
          display: inline-block;
          max-width: 88%;
        }
      }
      > .disStyle {
        display: inline-block;
        padding-right: 20px;
        width: 50%;
      }
    }
    div {
      button {
        margin-top: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.auditCashierContainer {
  .dialogsBox {
    ul {
      li {
        .ant-radio-group {
          line-height: 30px;
        }
      }
    }
  }
}
</style>
